module.exports = __webpack_public_path__ + "media/cards/23-d6649275.png";